import React, { FC, ReactElement } from "react";
import { SelectProps as RCSelectProps } from "rc-select";
import cn from "classnames";
import Select from "./index";
import stl from "./index.module.scss";
import Flag from "react-flagkit";
// may use just link from react-flagkit sources 'https://cdn.jsdelivr.net/gh/madebybowtie/FlagKit@2.2/Assets/SVG'

const LanguageSelect: FC<RCSelectProps> = ({
  className,
  dropdownClassName,
  children,
  ...props
}) => {
  return (
    <Select
      virtual={false}
      showSearch={false}
      menuItemSelectedIcon={false}
      {...props}
      className={cn(className, stl.language, stl.block)}
      dropdownClassName={cn(
        dropdownClassName,
        stl.languageDropdown,
        stl.dropdown
      )}
      showArrow={true}
    >
      {React.Children.map(children, (item) => {
        const itemT = item as ReactElement<{
          value?: string;
          flag?: string;
          children: ReactElement | ReactElement[];
        }>;
        return React.cloneElement(itemT, {
          children: [
            <span key={itemT.props.value} className={cn(stl.flag)}>
              <Flag country={itemT.props.flag?.toUpperCase()} />
            </span>,
            ...(Array.isArray(itemT.props.children)
              ? itemT.props.children
              : [itemT.props.children]),
          ],
        });
      })}
    </Select>
  );
};

export default LanguageSelect;
